import { THierarchyMode } from "qpr-base/configuration/types";
import { MappedData, RawData } from "./index.dto";

export const mapScorecardHierarchy = (
  data: RawData[] | undefined
): MappedData[] => {
  if (!data?.length) {
    return [];
  }
  const scorecards: MappedData[] = data.map((sc) => {
    return { ...sc, ...{ childelements: [] } };
  });

  let firstLevel = (scorecards[0] as any).level; // scorecards are sorted by level -> first sc has smallest level

  const result: MappedData[] = scorecards.filter(
    (sc) => (sc as any).level === firstLevel.toString()
  );

  const appendChildren = (scorecard: MappedData) => {
    scorecard.childelements = scorecards.filter(
      (sc) => (sc as any).parentid === scorecard.id
    );
    for (let i = 0; i < scorecard.childelements.length; i += 1)
      appendChildren(scorecard.childelements[i]);
  };
  result.forEach((sc) => appendChildren(sc));

  return result;
};

export const mapPerspectiveHierarchy = (
  data: RawData[] | undefined
): MappedData[] => {
  if (!data) {
    return [];
  }
  const objectives = data.filter(
    (cur: any) => cur.typename === "Strategic Objective"
  );

  // get perspectives
  const symbols: string[] = [];
  const perspectives: MappedData[] = data
    .filter((cur: any) => {
      if (cur.typename === "Perspective" && !symbols.includes(cur.symbol)) {
        symbols.push(cur.symbol);
        return true;
      }
      return false;
    })
    .map((curr) => {
      return { ...curr, ...{ childelements: [] } };
    });

  // attach objectives to perspectives
  for (let i = 0; i < objectives.length; i += 1) {
    const parent = data.find((mea) => mea.id === objectives[i].parentid);
    if (parent && parent.typename === "Perspective") {
      const per = perspectives.find((p: any) => p.symbol === parent.symbol);
      if (
        per &&
        !per.childelements.find((el: any) => el.symbol === objectives[i].symbol)
      ) {
        per.childelements.push({ ...objectives[i], ...{ childelements: [] } });
      }
    }
  }
  return perspectives;
};

export const mapKpisAndProjects = (
  selectedElement: MappedData | undefined,
  data: RawData[] | undefined,
  hierarchyMode: THierarchyMode
): { kpis: MappedData[]; projects: MappedData[] } => {
  if (!data) {
    return {
      projects: [],
      kpis: [],
    };
  }

  if (hierarchyMode === "Scorecards") {
    // return KPIs and Projects from top level scorecard
    const currentSCSymbol = selectedElement?.symbol || "L0";
    return {
      projects: data
        .filter(
          (cur: any) =>
            cur.scorecardsymbol === currentSCSymbol &&
            cur.typename === "Initiative"
        )
        .map((item) => {
          return { ...item, ...{ childelements: [] } };
        }),
      kpis: data
        .filter(
          (cur: any) =>
            cur.scorecardsymbol === currentSCSymbol && cur.typename === "KPI"
        )
        .map((item) => {
          return { ...item, ...{ childelements: [] } };
        }),
    };
  }

  let parentSymbols: any = undefined;
  if (selectedElement) {
    parentSymbols = selectedElement.childelements.map((e) => e.symbol);
    parentSymbols.push(selectedElement.symbol);
  }

  const kpis = data
    .filter(
      (cur: any) =>
        cur.typename === "KPI" &&
        (!parentSymbols || parentSymbols.includes(cur.parentsymbol))
    )
    .map((item) => {
      return { ...item, ...{ childelements: [] } };
    });

  const projects = data
    .filter(
      (cur: any) =>
        cur.typename === "Initiative" &&
        (!parentSymbols || parentSymbols.includes(cur.parentsymbol))
    )
    .map((item) => {
      return { ...item, ...{ childelements: [] } };
    });
  return {
    kpis,
    projects,
  };
};
